// Número de pedido legible para el CMS: usa el folio si existe; si no, quita
// los ceros a la izquierda de num_pedido (viene con padding "0000000123").
// Mismo criterio que la app y el POS.
export const formatOrderNumber = (order?: {
    folio?: number | string | null;
    num_pedido?: string | null;
} | null): string => {
    if (!order) return '';
    if (order.folio !== undefined && order.folio !== null && `${order.folio}` !== '') {
        return `${order.folio}`;
    }
    const raw = order.num_pedido ?? '';
    const stripped = raw.replace(/^0+/, '');
    return stripped || raw;
};
